import { useIntl } from "react-intl";
import React from "react";
import PcrContainer from "./pcr.container";

function PcrContainerIntl() {
    const intl = useIntl()
    return (
        <PcrContainer intl={intl}></PcrContainer>
    );
  }

  export default PcrContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/pcr/pcr.intl.js